
import { useState,useContext,createContext } from "react";
import axios from "axios";

const SearchContext = createContext();

const SearchProvider = ({children})=>{
    const [serch ,setSearch] = useState({
        keyword:"",
        results:[]

    }
    );

  
    return (
        <SearchContext.Provider value={[serch,setSearch]}>
            {children}
        </SearchContext.Provider>
    )

};


//custome hook

const useSearch = ()=>useContext(SearchContext)

export {useSearch,SearchProvider}

 